import { useEffect } from "react";
import { useAppSetting, getBrandingUrl } from "@/hooks/useAppSettings";

/**
 * Dynamically updates favicon and app icons based on app_settings.
 * Render once at the app root level.
 */
const DynamicHead = () => {
  const { data: faviconPath } = useAppSetting("favicon");
  const { data: appIconPath } = useAppSetting("app_icon");

  useEffect(() => {
    // getBrandingUrl already appends ?v= cache-buster — use as-is to avoid double query string
    const faviconUrl = getBrandingUrl(faviconPath);
    if (faviconUrl) {
      let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = faviconUrl;
    }
  }, [faviconPath]);

  useEffect(() => {
    // getBrandingUrl already appends ?v= cache-buster — use as-is to avoid double query string
    const iconUrl = getBrandingUrl(appIconPath);
    if (iconUrl) {
      // Update the primary apple-touch-icon (no sizes attribute)
      const appleLink = document.querySelector<HTMLLinkElement>("link[rel='apple-touch-icon']:not([sizes])");
      if (appleLink) appleLink.href = iconUrl;
    }
  }, [appIconPath]);

  return null;
};

export default DynamicHead;
